module.exports = {
  localeName: 'fr-BE',
  momentFormat: 'DD/MM/YYYY',
  qrCodeUrl: 'https://www.inmoment.com/websurvey/2/begin?gateway=NikeWEQRCode&base32=surveyCode&SurveyType=2&countryCode=56&loyaltyMember=1&PrintEreceipt=1&weqrcode=7',
  taxId: 'TVA magasin: ',
};
